import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterReport from 'views/reports/betsReport/filterReport'; // Importing FilterReport component
import TableReport from 'views/reports/betsReport/tableReport'; // Importing TableReport component
import TableTransactionsReport from 'views/reports/betsReport/recordTransReport'; // Importing TableTransactionsReport component
import RecordReport from 'views/reports/betsReport/recordReport'; // Importing RecordReport component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * BetsReportView class extending JetView to create a bets report view.
 */
export default class BetsReportView extends JetView {
    /**
     * Configures the layout of the BetsReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section configuration with RecordReport
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordReport],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left section configuration with toolbar, filter, and table reports
        const left = {
            height: screen.width < 500 ? 500 : 300, // Responsive height based on screen width
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying current theme to the toolbar
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Apuestas'), // Localized label for the report
                            width: 200,
                        },
                    ],
                },
                FilterReport, // Including FilterReport component
                TableReport, // Including TableReport component
                toolbar, // Including the toolbar with pagination
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main configuration object for the BetsReportView
        return {
            id: 'a5', // Unique identifier for the view
            type: 'clean', // Clean type for the view
            view: 'form', // Form view type
            scroll: 'y', // Vertical scrolling enabled
            rows: [
                {
                    responsive: 'a5', // Responsive configuration
                    type: 'wide',
                    cols: [
                        left, // Left section
                        (screen.width < 500
                            ? right // Conditional rendering based on screen width
                            : { id: 'res', view: 'resizer' }, // Resizer for larger screens
                        right), // Right section
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
